import {
  useQuery,
  type QueryClient,
  type UseQueryOptions,
} from '@tanstack/react-query';
import { StatusCode } from '@hungryroot/rest';
import {
  getPricingServiceCustomerPlansPrice,
  getPricingServiceCustomerPlansPricePath,
  type GetPricingServiceCustomerPlansPriceParams,
} from '@hungryroot/rest/api/v2/pricing_service/customers/[id]/plans/price/get';

const TIME_LIMIT_15_MINUTES = 15 * 60 * 1000;

const getQueryKey = (
  queryParams: GetPricingServiceCustomerPlansPriceParams
) => ['Customers', getPricingServiceCustomerPlansPricePath(queryParams)];

export function invalidatePlanServiceCustomerPlansPrice(
  client: QueryClient,
  queryParams: GetPricingServiceCustomerPlansPriceParams
) {
  client.invalidateQueries({ queryKey: getQueryKey(queryParams) });
}

export function usePricingServiceCustomerPlansPrice(
  queryParams: GetPricingServiceCustomerPlansPriceParams = {},
  options?: Pick<UseQueryOptions, 'enabled'>
) {
  return useQuery({
    queryKey: getQueryKey(queryParams),
    queryFn: async () => {
      const resp = await getPricingServiceCustomerPlansPrice(queryParams);

      if (resp.status !== StatusCode.SuccessOK) {
        throw new Error(JSON.stringify(resp.data, null, 2));
      }

      return resp.data;
    },
    ...options,
    gcTime: TIME_LIMIT_15_MINUTES,
    staleTime: TIME_LIMIT_15_MINUTES,
  });
}
